import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import './PausaModal.css';
import { Toaster, toast } from 'react-hot-toast';
import { GrupoContext } from '../GrupoContext';
import '../App2.css';
import SessionManager from '../componenteExtra/SessionManager';

const PauseModal = ({ isOpen, onRequestClose, activity }) => {
    const { grupo: staffName } = useContext(GrupoContext);
    const [selectedPause, setSelectedPause] = useState('');
    const [pauseOptions, setPauseOptions] = useState([]);
    const [definition, setDefinition] = useState('');
    const token = localStorage.getItem("access_token");

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/get_pause_states`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(response => setPauseOptions(response.data))
            .catch(error => console.error('Error fetching pause options:', error));
    }, []);

    const handlePause = async () => {
        const selectedOption = pauseOptions.find(option => option.id === parseInt(selectedPause));
        const toastId = toast.loading('Pausando actividad...');

        try {
            await axios.put(`${process.env.REACT_APP_BACKEND_URL}/update_activity_pause`, {
                id: activity.id,
                estado_pausa: selectedOption.id,
                definicion_pausa: selectedOption.id === 8 || selectedOption.id === 9 ? definition : selectedOption.definicion,
                pausa: selectedOption.estado_pausa
            }, {
                headers: { Authorization: `Bearer ${token}` },
            });

            toast.dismiss(toastId);
            toast.success('Actividad pausada correctamente');
            setTimeout(() => {
                onRequestClose();
                window.location.reload();
            }, 3000);
        } catch (error) {
            console.error('Error pausing activity:', error);
            toast.dismiss(toastId);
            toast.error('Error al pausar actividad: ' + error.message);
        }
    };

    const handlePauseChange = (e) => {
        const selectedId = parseInt(e.target.value);
        setSelectedPause(selectedId);

        const selectedOption = pauseOptions.find(option => option.id === selectedId);
        if (selectedOption) {
            if (selectedId === 8 || selectedId === 9) {
                setDefinition(''); // Permitir que el usuario escriba
            } else {
                setDefinition(selectedOption.definicion); // Usar la descripción predefinida
            }
        } else {
            setDefinition('');
        }
    };

    const handleUserInput = (e) => {
        const inputText = e.target.value;
        setDefinition(inputText.substring(0, 75)); // Limitar la entrada del usuario a 75 caracteres
    };

    return (
        <>
          <SessionManager />
          {isOpen ? (
            <div className="modal-overlay">
              <div className="modal-content">
                <h2>Pausar Actividad</h2>
                <div>
                  <label>Seleccionar Motivo de Pausa: </label>
                  <select value={selectedPause} onChange={handlePauseChange}>
                    <option value="">Seleccione un motivo</option>
                    {pauseOptions.map(option => (
                      <option key={option.id} value={option.id}>
                        {option.estado_pausa}
                      </option>
                    ))}
                  </select>
                </div>
                <textarea
                  value={definition}
                  onChange={(e) => (selectedPause === 8 || selectedPause === 9) && handleUserInput(e)}
                  placeholder="Describe el motivo de la pausa... (Máx. 75 caracteres)"
                  readOnly={!(selectedPause === 8 || selectedPause === 9)}
                />
                <button
                  onClick={handlePause}
                  disabled={!selectedPause || ((selectedPause === 8 || selectedPause === 9) && !definition.trim())}
                  className="enviar-btn"
                >
                  Enviar
                </button>
      
                <button onClick={onRequestClose} className="cerrar-btn">Cerrar</button>
              </div>
              <Toaster />
            </div>
          ) : null}
        </>
      );
    };

export default PauseModal;
